import { DatePicker, fromUtcDateValue, toUtcDateValue } from '@cinesend/ui-kit'

const Date = ({ type, asset, saveAsset, disabled }) => {
  const key = type === 'Start' ? 'start_date' : 'end_date'
  return (
    <>
      {(type === 'Start' || type === 'End') && (
        <DatePicker
          fullWidth
          label={`${type} Date`}
          value={toUtcDateValue(asset[key])}
          onValueChange={(value) => saveAsset({ [key]: fromUtcDateValue(value) })}
          disabled={disabled}
        />
      )}
    </>
  )
}

export default Date
